export default {"src":"/_next/static/media/pharma.d3c191e9.svg","height":45,"width":42};